import React from 'react';

import AppButton from 'rebook/apps/base/components/AppButton';

import styles from './style.scss';


const BottomBlock = () => (
  <div className={styles.bottomContent}>
    <div className={styles.footerContainer}>
      <div className={styles.footerImage} />
      <div className={styles.info}>
        <div className="title-2">Читайте и слушайте где угодно</div>
        <div>
          <p>Дома и по пути – в удобном приложении даже без интернета</p>
          <AppButton target="landing_banner" extraClassName={styles.appButton} />
        </div>
      </div>
    </div>
  </div>
);

export default BottomBlock;
